import {SurveyCreate, SurveyResource} from '@/interfaces';
import {CrudApiAbstract} from '@/api/CrudApiAbstract';
import {ResourceType} from '@/enums';

export class SurveyApi extends CrudApiAbstract<SurveyResource, SurveyCreate> {
  public constructor() {
    super(`${ResourceType.Survey}s`);
  }
}
